const local: App.I18n.Schema = {
  system: {
    title: 'BI 系统'
  },
  common: {
    action: '操作',
    add: '新增',
    addSuccess: '添加成功',
    backToHome: '返回首页',
    batchDelete: '批量删除',
    cancel: '取消',
    close: '关闭',
    check: '勾选',
    expandColumn: '展开列',
    columnSetting: '列设置',
    config: '配置',
    confirm: '确认',
    view: '查看',
    delete: '删除',
    deleteSuccess: '删除成功',
    confirmDelete: '确认删除吗？此操作无法恢复',
    edit: '编辑',
    index: '序号',
    keywordSearch: '请输入关键词搜索',
    logout: '退出登录',
    logoutConfirm: '确认退出登录吗？',
    lookForward: '敬请期待',
    modify: '修改',
    fill: '填写',
    set: '设置',
    modifySuccess: '修改成功',
    noData: '无数据',
    operate: '操作',
    pleaseCheckValue: '请检查输入的值是否合法',
    refresh: '刷新',
    reset: '重置',
    search: '搜索',
    switch: '切换',
    tip: '提示',
    trigger: '触发',
    update: '更新',
    updateSuccess: '更新成功',
    userCenter: '个人中心',
    yesOrNo: {
      yes: '是',
      no: '否'
    }
  },
  request: {
    logout: '请求失败后登出用户',
    logoutMsg: '用户状态失效，请重新登录',
    logoutWithModal: '请求失败后弹出模态框再登出用户',
    logoutWithModalMsg: '用户状态失效，请重新登录',
    refreshToken: '请求的token已过期，刷新token',
    tokenExpired: 'token已过期'
  },
  theme: {
    themeSchema: {
      title: '主题模式',
      light: '亮色模式',
      dark: '暗黑模式',
      auto: '跟随系统'
    },
    grayscale: '灰度模式',
    layoutMode: {
      title: '布局模式',
      vertical: '左侧菜单模式',
      'vertical-mix': '左侧菜单混合模式',
      horizontal: '顶部菜单模式',
      'horizontal-mix': '顶部菜单混合模式'
    },
    recommendColor: '应用推荐算法的颜色',
    recommendColorDesc: '推荐颜色的算法参照',
    themeColor: {
      title: '主题颜色',
      primary: '主色',
      info: '信息色',
      success: '成功色',
      warning: '警告色',
      error: '错误色',
      followPrimary: '跟随主色'
    },
    scrollMode: {
      title: '滚动模式',
      wrapper: '外层滚动',
      content: '主体滚动'
    },
    page: {
      animate: '页面切换动画',
      mode: {
        title: '页面切换动画类型',
        'fade-slide': '滑动',
        fade: '淡入淡出',
        'fade-bottom': '底部消退',
        'fade-scale': '缩放消退',
        'zoom-fade': '渐变',
        'zoom-out': '闪现',
        none: '无'
      }
    },
    fixedHeaderAndTab: '固定头部和标签栏',
    header: {
      height: '头部高度',
      breadcrumb: {
        visible: '显示面包屑',
        showIcon: '显示面包屑图标'
      }
    },
    tab: {
      visible: '显示标签栏',
      cache: '缓存标签页',
      height: '标签栏高度',
      mode: {
        title: '标签栏风格',
        chrome: '谷歌风格',
        button: '按钮风格'
      }
    },
    sider: {
      inverted: '深色侧边栏',
      width: '侧边栏宽度',
      collapsedWidth: '侧边栏折叠宽度',
      mixWidth: '混合布局侧边栏宽度',
      mixCollapsedWidth: '混合布局侧边栏折叠宽度',
      mixChildMenuWidth: '混合布局子菜单宽度'
    },
    footer: {
      visible: '显示底部',
      fixed: '固定底部',
      height: '底部高度',
      right: '底部局右'
    },
    themeDrawerTitle: '主题配置',
    pageFunTitle: '页面功能',
    configOperation: {
      copyConfig: '复制配置',
      copySuccessMsg: '复制成功，请替换 src/theme/settings.ts 中的变量 themeSettings',
      resetConfig: '重置配置',
      resetSuccessMsg: '重置成功'
    }
  },
  route: {
    login: '登录',
    403: '无权限',
    404: '页面不存在',
    500: '服务器错误',
    'iframe-page': '外链页面',
    home: '首页',
    'ad-serving-data': '投放分析',
    'ad-serving-data_data': '投放数据',
    'ad-serving-data_material-statistics': '投放素材',
    'ad-serving-data_fraud-source': '假量来源',
    'user-center': '个人中心',
    tools: '工具集',
    function: '系统功能',
    function_tab: '标签页',
    'function_multi-tab': '多标签页',
    'function_hide-child': '隐藏子菜单',
    'function_hide-child_one': '隐藏子菜单',
    'function_hide-child_two': '菜单二',
    'function_hide-child_three': '菜单三',
    function_request: '请求',
    'function_toggle-auth': '切换权限',
    'function_super-page': '超级管理员可见',
    manage: '系统管理',
    manage_user: '权限管理',
    'manage_user-detail': '用户详情',
    manage_role: '角色管理',
    manage_menu: '菜单管理',
    apikey: 'MCP 访问密钥',
    'app-manage': '应用管理',
    'statistics': '统计',
    'user-segment-query': '用户分组',
    'user-segment-query_user-segment-label': '分组标签',
    'user-segment-query_user-segment-analysis': '分组数据',
    'app-manage_app-store-detail': '应用详情',
    'statistics_app-event-mnage': '事件详情',
    'app-manage_app-user': '用户数据',
    'app-manage_app-list': '应用列表',
    'app-manage_monitor': '监控与改进',
    'app-manage_store-review': '商店评论',
    'manage_logprocessmgr': '日志处理管理',
    'statistics_cohort-analysis': "同期群分析",
    'statistics_ad-event': "事件总览",
    'statistics_ab-test': "AB Test",
    'statistics_user-activity-query': "用户活动查询",
    'report-monitor': "报表监控",
    'statistics_report-download': "自定义报表",
    'statistics_game-level': "关卡统计",
    'statistics_ad-detail': "变现统计",
    'statistics_churn-statistics': "流失统计",
    'statistics_network-status-distribution': '网络状态分布'
    ,'statistics_roas-analysis': '低质量来源分析',
    'statistics_roas-app-config': 'ROAS 应用配置',
    'statistics_roas-adgroups': 'ROAS 广告组列表',
    'statistics_roas-adgroup-detail': 'ROAS 广告组详情',
    'statistics_roas-compare': 'ROAS 数据对比',
  },
  page: {
    abTest: {
      eventCount: '事件数',
      eventUsers: '达成事件用户数',
      eventCountPerDau: '每活跃用户事件数'
    },
    reportDownload: {
      queryResult: '查询结果（{count} 行）',
      downloadCsv: '下载 CSV',
      table: '表格',
      lineChart: '折线图',
      barChart: '柱状图',
      displayMetric: '显示指标',
      selectMetric: '请选择指标',
      noChartMetric: '当前查询结果中没有可显示的指标',
      chartRequiresDay: '图表仅支持包含“日”维度的查询',
      chartDimensionLimit: '除“日”以外最多只能选择一个其他维度'
    },
    login: {
      common: {
        loginOrRegister: '登录 / 注册',
        userNamePlaceholder: '请输入用户名/邮箱',
        emailPlaceholder: '请输入邮箱',
        phonePlaceholder: '请输入手机号',
        codePlaceholder: '请输入验证码',
        passwordPlaceholder: '请输入密码',
        confirmPasswordPlaceholder: '请再次输入密码',
        codeLogin: '验证码登录',
        confirm: '确定',
        back: '返回',
        validateSuccess: '验证成功',
        loginSuccess: '登录成功',
        welcomeBack: '欢迎回来，{userName} ！'
      },
      pwdLogin: {
        title: '密码登录',
        rememberMe: '记住我',
        forgetPassword: '忘记密码？',
        register: '注册账号',
        otherAccountLogin: '其他账号登录',
        otherLoginMode: '其他登录方式',
        superAdmin: '超级管理员',
        admin: '管理员',
        user: '普通用户'
      },
      codeLogin: {
        title: '验证码登录',
        getCode: '获取验证码',
        reGetCode: '{time}秒后重新获取',
        sendCodeSuccess: '验证码发送成功',
        imageCodePlaceholder: '请输入图片验证码'
      },
      register: {
        title: '注册账号',
        agreement: '我已经仔细阅读并接受',
        protocol: '《用户协议》',
        policy: '《隐私权政策》'
      },
      resetPwd: {
        title: '重置密码',
        resetSuccess: '密码已重置，重置通知邮件已发送，请查收邮箱'
      },
      bindWeChat: {
        title: '绑定微信'
      }
    },
    about: {
      title: '关于',
      introduction: `BISystem 是一个优雅且功能强大的后台管理模板，基于最新的前端技术栈，包括 Vue3, Vite5, TypeScript, Pinia 和 UnoCSS。它内置了丰富的主题配置和组件，代码规范严谨，实现了自动化的文件路由系统。此外，它还采用了基于 ApiFox 的在线Mock数据方案。BISystem 为您提供了一站式的后台管理解决方案，无需额外配置，开箱即用。同样是一个快速学习前沿技术的最佳实践。`,
      projectInfo: {
        title: '项目信息',
        version: '版本',
        latestBuildTime: '最新构建时间',
        githubLink: 'Github 地址',
        previewLink: '预览地址'
      },
      prdDep: '生产依赖',
      devDep: '开发依赖'
    },
    home: {
      greeting: '早安，{userName}, 今天又是充满活力的一天!',
      projectCount: '项目数',
      todo: '待办',
      message: '消息',
      installCount: '安装量',
      activity: '日活',
      schedule: '作息安排',
      study: '学习',
      work: '工作',
      rest: '休息',
      entertainment: '娱乐',
      visitCount: '访问量',
      turnover: '成交额',
      dealCount: '成交量',
      creativity: '创意',
      revenue: '收入',
      session: '会话',
      actual: '实际值',
      predict: '预测值',
      totalValue: '总和',
      cpi: 'CPI',
      ltvOver90d: '三个月前用户LTV',
      ltvOver180d: '半年前用户LTV',
      ltvPredictD180: '180后天预测LTV'
    },
    function: {
      tab: {
        tabOperate: {
          title: '标签页操作',
          addTab: '添加标签页',
          addTabDesc: '跳转到关于页面',
          closeTab: '关闭标签页',
          closeCurrentTab: '关闭当前标签页',
          closeAboutTab: '关闭"关于"标签页',
          addMultiTab: '添加多标签页',
          addMultiTabDesc1: '跳转到多标签页页面',
          addMultiTabDesc2: '跳转到多标签页页面(带有查询参数)'
        },
        tabTitle: {
          title: '标签页标题',
          changeTitle: '修改标题',
          change: '修改',
          resetTitle: '重置标题',
          reset: '重置'
        }
      },
      multiTab: {
        routeParam: '路由参数',
        backTab: '返回 function_tab'
      },
      toggleAuth: {
        toggleAccount: '切换账号',
        authHook: '权限钩子函数 `hasAuth`',
        superAdminVisible: '超级管理员可见',
        adminVisible: '管理员可见',
        adminOrUserVisible: '管理员和用户可见'
      },
      request: {
        repeatedErrorOccurOnce: '重复请求错误只出现一次',
        repeatedError: '重复请求错误',
        repeatedErrorMsg1: '自定义请求错误 1',
        repeatedErrorMsg2: '自定义请求错误 2'
      }
    },
    apikey: {
      title: 'MCP 访问密钥',
      keyName: '名称',
      keyId: '密钥 ID',
      status: '状态',
      statusMap: {
        active: '有效',
        revoked: '已吊销',
        expired: '已过期'
      },
      createdAt: '创建时间',
      lastUsedAt: '最近使用',
      expiresAt: '过期时间',
      addKey: '新建密钥',
      revoke: '吊销',
      confirmRevoke: '确认吊销这把密钥吗？吊销后使用它的 agent 会立即失效',
      revokeSuccess: '已吊销',
      expiresIn: '有效期',
      expiresOption: {
        d30: '30 天',
        d90: '90 天',
        d180: '180 天',
        d365: '365 天',
        never: '永不过期'
      },
      form: {
        keyName: '请输入名称，便于区分用途，如 Claude Desktop'
      },
      createTip: '密钥明文只在创建成功时返回一次，关闭后无法再取回，丢失只能吊销重发。',
      issuedTitle: '密钥已创建',
      issuedTip: '请立即复制保存。关闭本窗口后将无法再次查看明文。',
      copy: '复制密钥',
      copied: '已复制',
      copySuccess: '已复制到剪贴板',
      copyUnsupported: '当前浏览器环境不支持自动复制，请手动选中复制',
      savedIt: '我已保存',
      usageTitle: '如何使用',
      usageEndpoint: 'MCP 端点',
      usageHeader: '请求头',
      usageScope: '密钥不额外携带权限，通过它读到的数据与你在本系统登录后看到的完全一致。'
    },
    manage: {
      common: {
        status: {
          disable: '禁用',
          enable: '启用'
        }
      },
      role: {
        title: '角色列表',
        roleName: '角色名称',
        roleCode: '角色编码',
        roleStatus: '角色状态',
        roleDesc: '角色描述',
        menuAuth: '菜单权限',
        appStatisticAuth: '数据浏览权限',
        form: {
          roleName: '请输入角色名称',
          roleCode: '请输入角色编码',
          roleStatus: '请选择角色状态',
          roleDesc: '请输入角色描述'
        },
        addRole: '新增角色',
        editRole: '编辑角色'
      },
      user: {
        title: '用户列表',
        userName: '用户名',
        password: '密码',
        userGender: '性别',
        nickName: '昵称',
        userPhone: '手机号',
        userEmail: '邮箱',
        userStatus: '用户状态',
        userRole: '用户角色',
        form: {
          userName: '请输入用户名',
          password: '请输入密码',
          userGender: '请选择性别',
          nickName: '请输入昵称',
          userPhone: '请输入手机号',
          userEmail: '请输入邮箱',
          userStatus: '请选择用户状态',
          userRole: '请选择用户角色'
        },
        addUser: '新增用户',
        editUser: '编辑用户',
        resetPassword: '重置密码',
        confirmResetPassword: '确认重置该用户密码？新密码将通过邮件发送给用户。',
        resetPasswordSuccess: '密码重置成功，已发送邮件通知用户',
        viewApp: '查看应用',
        gender: {
          undefine: '未知',
          male: '男',
          female: '女'
        }
      },

      menu: {
        home: '首页',
        title: '菜单列表',
        id: 'ID',
        parentId: '父级菜单ID',
        topLevelMenu: '顶级菜单',
        menuType: '菜单类型',
        menuName: '菜单名称',
        routeName: '路由名称',
        routePath: '路由路径',
        pathParam: '路径参数',
        layout: '布局',
        page: '页面组件',
        i18nKey: '国际化key',
        icon: '图标',
        localIcon: '本地图标',
        iconTypeTitle: '图标类型',
        order: '排序',
        constant: '常量路由',
        keepAlive: '缓存路由',
        href: '外链',
        hideInMenu: '隐藏菜单',
        activeMenu: '高亮的菜单',
        multiTab: '支持多页签',
        fixedIndexInTab: '固定在页签中的序号',
        query: '路由参数',
        button: '按钮',
        buttonCode: '按钮编码',
        buttonDesc: '按钮描述',
        menuStatus: '菜单状态',
        statusNormal: '正常',
        statusDisabled: '停用',
        visibleShow: '显示',
        visibleHidden: '隐藏',
        menuPerms: '权限标识',
        menuDesc: '备注',
        form: {
          home: '请选择首页',
          menuType: '请选择菜单类型',
          menuName: '请输入菜单名称',
          parentId: '请选择父级菜单',
          menuPerms: '请输入权限标识，如 auth::sys::menu',
          menuDesc: '请输入备注',
          routeName: '请输入路由名称',
          routePath: '请输入路由路径',
          pathParam: '请输入路径参数',
          page: '请选择页面组件',
          layout: '请选择布局组件',
          i18nKey: '请输入国际化key',
          icon: '请输入图标',
          localIcon: '请选择本地图标',
          order: '请输入排序',
          keepAlive: '请选择是否缓存路由',
          href: '请输入外链',
          hideInMenu: '请选择是否隐藏菜单',
          activeMenu: '请选择高亮的菜单的路由名称',
          multiTab: '请选择是否支持多标签',
          fixedInTab: '请选择是否固定在页签中',
          fixedIndexInTab: '请输入固定在页签中的序号',
          queryKey: '请输入路由参数Key',
          queryValue: '请输入路由参数Value',
          button: '请选择是否按钮',
          buttonCode: '请输入按钮编码',
          buttonDesc: '请输入按钮描述',
          menuStatus: '请选择菜单状态'
        },
        addMenu: '新增菜单',
        editMenu: '编辑菜单',
        addChildMenu: '新增子菜单',
        type: {
          directory: '目录',
          menu: '菜单'
        },
        iconType: {
          iconify: 'iconify图标',
          local: '本地图标'
        }
      }
    },
    userCenter: {
      account: '账号',
      subscription: '信息订阅',
      subscriptionSettings: '订阅设置',
      subscriptionEnabled: '开启订阅',
      subscriptionDisabled: '未开启',
      subscribedApps: '订阅应用',
      subscribedAppsEmpty: '未选择应用',
      subscribedAppsCount: '已选择 {count} 个应用',
      selectSubscribedApps: '请选择要订阅的应用',
      subscribedAppsHint: '开启订阅且订阅应用为空，视为订阅当前账号所有权限应用',
      subscribedAlerts: '订阅告警',
      selectAllAlerts: '全选',
      selectedSourcesCount: '已选中 {count} 项',
      allAlerts: '全部告警',
      security: '安全',
      integration: '集成与偏好',
      dataAccess: '数据权限',
      visibleApps: '可见应用',
      visibleChannels: '可见渠道',
      revenuePerm: '收入权限',
      expensePerm: '花费权限',
      granted: '已授权',
      notGranted: '未授权',
      all: '全部',
      unitApp: '{count} 个应用',
      unitChannel: '{count} 个渠道',
      unset: '未填写',
      noRole: '未分配角色',
      tokenUnset: '未设置',
      dataSourcePref: '数据源偏好',
      siteDefault: '跟随站点默认',
      adjustTokenTip: '从 Adjust 后台获取的 API Token',
      save: '保存'
    },
    muti_menu: {
      first: {
        appid: '应用',
        revenueThreshold: '收入阈值'
      },
      appUser: {
        searchApp: '搜索应用',
        channels: '渠道源',
        searchChannels: '搜索渠道源',
        installDate: '安装日期',
        userProfileFields: '展示字段',
        selectAllFields: '全选',
        userId: '用户ID',
        exportAnomaly: '导出作弊用户',
        exportVisibleCsv: '导出 CSV（展示的数据）',
        exportCsv: '导出 CSV（原始数据）',
        fields: {
          appid: 'App Id',
          ltv: 'LTV',
          device_id: '设备ID',
          device_id_idfv: 'IDFV设备ID',
          adjust_id: 'Adjust ID',
          brand: '品牌',
          model: '型号',
          ram: '内存',
          screen_size: '屏幕尺寸',
          screen_dpi: '屏幕DPI',
          device_language: '设备语言',
          device_country: '设备国家',
          ip_country: 'IP国家',
          ip_city: 'IP城市',
          install_time: '安装时间',
          channel_source: '渠道来源',
          campaign: '广告系列',
          adgroup: '广告组',
          creative: '广告素材',
          network_status: '网络状态',
          is_emulator: '是否模拟器',
          is_root: '是否Root',
          last_active_time: '最后活跃时间',
          active_days: '活跃天数',
          current_login_streak: '当前连续登录'
        }
      },
      networkStatus: {
        reportVolume: '上报量',
        causeBreakdown: '「不可达」的成因拆解',
        causeBreakdownNote: '使用汇总接口返回的四类不可达占比。',
        networkComposition: '网络状态构成',
        barRepresentsTotal: '下条 = 100%',
        noNetwork: '无网络',
        onlyCell: 'only cell',
        onlyWifi: 'only wifi',
        wifiAndCell: 'wifi&cell'
      },
      second: {
        applicationlist: '应用列表',
        viewStore: '查看商店',
        applicationDetail: '应用详情',
        basicInfo: '基础信息',
        description: '应用描述',
        media: '媒体资源',
        reviews: '评论',
        versionRelease: '版本发布信息',
        backApplicationList: '返回应用列表',
        generateReplyList: '生成回复列表',
        generateReplyFailed: '生成失败',
        generateReplyPartialFailed: '{count} 条回复生成失败',
        selectAllReviews: '全选评论',
        selectAllReplies: '全选回复',
        sendAllReplies: '发送选中回复',
        monitorCountry: '监控地区',
        receiveAlarm: '接收告警',
        confirmUpdateApplicationDetail: '确认将{label}更新为 {value} 吗？',
        confirmReceiveAlarm: '确认接收告警吗？',
        confirmIgnoreAlarm: '确认不再接收告警吗？',
        storeReview: {
          overview: '概览',
          searchApp: '搜索应用',
          packageName: '包名',
          appName: '应用名称',
          author: '作者',
          rating: '评分',
          rate: '评分',
          min: '最小',
          max: '最大',
          reviewReplyStatus: '回复状态',
          replied: '已回复',
          aiSuggestedReply: 'AI建议回复',
          aiSuggestedNoReply: 'AI建议不回复',
          aiReplyNotGenerated: '未调用AI生成回复',
          preparedReply: 'AI\u5DF2\u751F\u6210\u56DE\u590D',
          reviewTime: '评论时间',
          review: '评论',
          reply: '回复',
          developer: '开发者账户',
          developerReply: '已回复内容',
          pendingReply: '待发送回复',
          aiGeneratedReply: 'AI 生成回复内容',
          sendThisReply: '发送此回复',
          resendThisReply: '\u91CD\u65B0\u53D1\u9001',
          replyTime: '回复时间',
          aiNoReplySuggestion: 'AI建议无需回复',
          preparedReplyFailed: 'AI生成回复失败',
          appVersion: '应用版本',
          appVersionPlaceholder: '请选择'
        },
        sendResult: '发送结果'
      },
      logprocessmgr: {
        title: '日志处理任务管理',
        status: '当前运行状态',
        begintime: '开始时间',
        processedfiles: '已处理文件数',
        nexttime: '下次开始时间',
        manualstart: '手动启动',
        refresh: '刷新',
        processspeed: '处理速度'
      }
    },
    cohort: {
      common: {
        cohortAnalysis: '同期群分析'
      }
    }
  },
  form: {
    required: '不能为空',
    userName: {
      required: '请输入用户名',
      invalid: '用户名格式不正确'
    },
    phone: {
      required: '请输入手机号',
      invalid: '手机号格式不正确'
    },
    pwd: {
      required: '请输入密码',
      invalid: '密码格式不正确，6-18位字符，包含字母、数字、下划线'
    },
    confirmPwd: {
      required: '请输入确认密码',
      invalid: '两次输入密码不一致'
    },
    code: {
      required: '请输入验证码',
      invalid: '验证码格式不正确'
    },
    email: {
      required: '请输入邮箱',
      invalid: '邮箱格式不正确'
    }
  },
  dropdown: {
    closeCurrent: '关闭',
    closeOther: '关闭其它',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeAll: '关闭所有'
  },
  icon: {
    themeConfig: '主题配置',
    themeSchema: '主题模式',
    lang: '切换语言',
    fullscreen: '全屏',
    fullscreenExit: '退出全屏',
    reload: '刷新页面',
    collapse: '折叠菜单',
    expand: '展开菜单',
    pin: '固定',
    unpin: '取消固定'
  },
  datatable: {
    itemCount: '共 {total} 条'
  }
};

export default local;
